var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5933 19.5688C33.5643 10.9569 28.1807 2.37769 19.5688 0.406698C10.9569 -1.5643 2.37769 3.81926 0.406698 12.4312C-1.5643 21.0431 3.81926 29.6223 12.4312 31.5933C21.0431 33.5643 29.6223 28.1807 31.5933 19.5688Z",
    fill: "#E4E7EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1907 6.28922C17.1321 6.20669 18.387 8.17897 20.7995 13.371C20.9554 13.7063 21.1259 13.9607 21.3058 14.1593C20.3897 14.6587 19.6544 15.4478 19.223 16.4036C18.1334 16.5393 16.8067 16.8543 15.2529 17.4309C10.5571 19.1736 8.98585 21.4655 9.23133 22.1532C9.37417 22.5521 12.7495 23.4473 16.857 21.9236C17.8153 21.568 18.6611 21.1406 19.3926 20.6886C19.6361 21.1306 19.9471 21.5302 20.3119 21.8733C19.4375 22.4203 18.4441 22.9184 17.3554 23.3224C12.7569 25.0281 8.39755 24.335 7.80607 22.6802C7.39274 21.5217 7.72407 20.925 8.06745 20.3067C8.39651 19.7141 8.73663 19.1016 8.44305 17.9558C7.01885 12.3976 6.73634 10.0656 9.80693 7.54412C10.3483 7.09964 10.3972 6.73287 10.4379 6.42766C10.4794 6.11603 10.5124 5.86858 11.0523 5.66812C11.5936 5.46755 11.7753 5.63575 12.004 5.84747C12.2277 6.05459 12.4964 6.30335 13.1907 6.28922ZM10.9306 20.7544C11.8977 19.9344 13.3896 19.0234 15.5365 18.2266C15.8158 18.1219 16.0878 18.0277 16.3534 17.941L16.3703 17.979C16.7628 19.0773 15.7693 20.4539 14.1536 21.0517C12.8849 21.5226 11.611 21.3723 10.9306 20.7544Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11090_66374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7999 17.2L22.3999 19.6M22.3999 17.2L24.7999 19.6",
    stroke: "white",
    strokeWidth: 1.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11090_66374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.8,
    height: 4.8,
    fill: "white",
    transform: "translate(21.2 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.9f52d613a79ae7dde8cf1b13a711b453.svg";
export { ForwardRef as ReactComponent };